import React from "react";


import Activity from "./components/activity"
import "./Activities.css";
const Activities = () => {
  return (
    <>
      <div className="educ_cert" id="my-activities">
        
        <Activity/>
        
        
      
      </div>
    </>
  );
};

export default Activities;
